<template>
    <input v-model="formula" @keydown.enter="rollDice" placeholder="Dice Formula" />
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
    data() {
        return {
            formula: '',
        };
    },
    computed: {
        ...mapState('live', {
            sessionId: 'sessionId',
            director: 'director',
            userId: 'userId',
        }),
    },
    methods: {
        rollDice() {
            var diceRoll = {
                timestamp: +moment(),
                userId: this.$store.getters.oidcUser.preferred_username, // TODO might not be the right place to be grabbing this
                sessionId: this.sessionId,
                formula: this.formula,
            };
            this.director.submitRoll(diceRoll);
        },
    },
};
</script>

<style scoped>
.container {
    overflow-x: auto;
    bottom: 5px;
    right: 5px;
    padding: 0.5em;
    background-color: #ddd;
    font: x-small Consolas, Monaco, monospace;
    color: black;
    border: 2px solid #345;
}
</style>
